import * as React from 'react';

function SvgClock(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
            fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11 7H13V11.5858L15.7071 14.2929L14.2929 15.7071L11 12.4142V7Z"
            fill="currentColor"/>
    </svg>
  );
}

export default SvgClock;
